import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthShell } from "../components/AuthShell";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

const QUESTIONS = [
  "What city were you born in?",
  "What was the name of your first pet?",
  "What is your mother's maiden name?",
  "What was your first school's name?",
  "What is your favorite book?",
];

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    email: "", password: "", confirm: "", invitation_code: "",
    security_question: QUESTIONS[0], security_answer: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password !== form.confirm) { setError("Passwords do not match"); return; }
    if (form.password.length < 8) { setError("Password must be at least 8 characters"); return; }
    setLoading(true);
    try {
      await register({
        email: form.email, password: form.password,
        invitation_code: form.invitation_code,
        security_question: form.security_question,
        security_answer: form.security_answer,
      });
      nav("/");
    } catch (err) {
      setError(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell heading="Create your account" subtitle="Registration requires a valid invitation code.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        {error && <div className="border border-danger/40 bg-danger/10 text-danger text-sm px-3 py-2" data-testid="register-error">{error}</div>}
        <div className="space-y-2">
          <Label htmlFor="inv">Invitation Code</Label>
          <Input id="inv" value={form.invitation_code} onChange={set("invitation_code")} required data-testid="register-invitation" placeholder="MFC-XXXXXX-XXXXXX" className="font-mono" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={form.email} onChange={set("email")} required data-testid="register-email" placeholder="you@example.com" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-2">
            <Label htmlFor="pw">Password</Label>
            <Input id="pw" type="password" value={form.password} onChange={set("password")} required data-testid="register-password" placeholder="Min 8 chars" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="cf">Confirm</Label>
            <Input id="cf" type="password" value={form.confirm} onChange={set("confirm")} required data-testid="register-confirm" placeholder="Repeat" />
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="sq">Security Question</Label>
          <select id="sq" value={form.security_question} onChange={set("security_question")} data-testid="register-question"
            className="w-full h-10 border border-input bg-background px-3 text-sm">
            {QUESTIONS.map((q) => <option key={q} value={q}>{q}</option>)}
          </select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="sa">Security Answer</Label>
          <Input id="sa" value={form.security_answer} onChange={set("security_answer")} required data-testid="register-answer" placeholder="Used for password recovery" />
        </div>
        <Button type="submit" className="w-full rounded-none h-11" disabled={loading} data-testid="register-submit">
          {loading ? "Creating…" : "Create Account"}
        </Button>
        <p className="text-sm text-muted-foreground text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-primary hover:underline font-medium" data-testid="login-link">Sign in</Link>
        </p>
      </form>
    </AuthShell>
  );
}
